
<template>
    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
        <h3>Account Summary</h3>
        <div class="card">
            <div class="card-header">
                <h5>Aging</h5>
            </div>
            <div class="card-divider"></div>
            <div class="card-table">
                <div class="table-responsive-md">
                    <table>
                        <thead>
                            <tr>
                                <th>Age Period</th>
                                <th class="account-table-right">Amount Due</th>
                                <th class="account-table-right">Percent</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{future_caption}}</td>
                                <td class="account-table-right">{{ toUSD(future_due) }}</td>
                                <td class="account-table-right">{{ future_due_perc }}%</td>													
                            </tr>
                            <tr>
                                
                                <td>{{current_month_caption}}</td>
                                <td class="account-table-right">{{ toUSD(current_month) }}</td>
                                <td class="account-table-right">{{ current_month_perc }}%</td>
                            </tr>
                            <tr>
                                <td>{{current_due_caption}}</td>
                                <td class="account-table-right">{{ toUSD(current_due) }}</td>
                                <td class="account-table-right">{{ current_due_perc }}%</td>													
                            </tr>
                            <tr>
                                <td>{{day3160_caption}}</td>
                                <td class="account-table-right">{{ toUSD(day3160) }}</td>
                                <td class="account-table-right">{{ day3160_perc }}%</td>													
                            </tr>
                            <tr>
                                <td>{{day6190_caption}}</td>
                                <td class="account-table-right">{{ toUSD(day6190) }}</td>
                                <td class="account-table-right">{{ day6190_perc }}%</td>													
                            </tr>
                            <tr>
                                <td>{{day91_caption}}</td>
                                <td class="account-table-right">{{ toUSD(day91_plus) }}</td>
                                <td class="account-table-right">{{ day91_plus_perc }}%</td>													
                            </tr>												
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><strong>Total Owed</strong></td>
                                <td class="account-table-right"><strong>{{ toUSD(total_owed)}}</strong></td>
                                <td class="account-table-right"><strong>{{ total_owed_perc }}%</strong></td>													
                            </tr>
                            <tr>
                                <td><strong>Past Due</strong></td>
                                <td class="account-table-right"><strong>{{ toUSD(past_due)}}</strong></td>
                                <td class="account-table-right"><strong>{{ past_due_perc }}%</strong></td>													
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="card-divider"></div>                                
        </div>
        
        <div class="block-space--layout--divider-xs"></div>
        <div class="card">
            <div class="card-header">
                <h5>Credit</h5>
            </div>
            <div class="card-divider"></div>
            <div class="card-table">
                <div class="table-responsive-md">
                    <table>
                        <tbody>
                            <tr>
                                <td><strong>Credit Limit</strong></td>
                                <td class="account-table-right">{{ credit_limit }}</td>
                                <td class="account-table-right"></td>													
                            </tr>
                            <tr>
                                
                                <td><strong>Open Order Amount</strong></td>
                                <td class="account-table-right">{{ toUSD(open_order)}}</td>
                                <td class="account-table-right"></td>
                            </tr>
                            <tr>
                                <td><strong>Total Owed</strong></td>
                                <td class="account-table-right">{{ toUSD(total_owed)}}</td>
                                <td class="account-table-right"></td>													
                            </tr>
                            <tr>
                                <td><strong>Available Credit</strong></td>
                                <td class="account-table-right">{{ toUSD(available_credit)}}</td>
                                <td class="account-table-right"></td>													
                            </tr>
                            <tr>
                                <td><strong>Last Payment</strong></td>
                                <td class="account-table-right">{{ last_payment }}</td>
                                <td class="account-table-right">{{last_payment_date}}</td>													
                            </tr>
                            <tr>
                                <td><strong>Last Invoice</strong></td>
                                <td class="account-table-right">{{ last_invoice }}</td>
                                <td class="account-table-right">{{ last_invoice_date }}</td>													
                            </tr>																		
                            <tr>
                                <td><strong>Total Owed</strong></td>
                                <td class="account-table-right">{{ toUSD(total_owed)}}</td>
                                <td class="account-table-right">{{ total_owed_perc }}%</td>													
                            </tr>
                            <tr>
                                <td><strong>Past Due</strong></td>
                                <td class="account-table-right">{{ toUSD(past_due)}}</td>
                                <td class="account-table-right">{{ past_due_perc }}%</td>													
                            </tr>
                            <tr>
                                <td><strong>MTD Purchases</strong></td>
                                <td class="account-table-right">{{toUSD(mtd_purchases)}}</td>
                                <td class="account-table-right"></td>													
                            </tr>
                            <tr>
                                <td><strong>YTD Purchases</strong></td>
                                <td class="account-table-right">{{toUSD(ytd_purchases)}}</td>
                                <td class="account-table-right"></td>													
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-divider"></div>                                
        </div>
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import Price from '../../../mixins/price.js';

export default {
    data() {
        return {
            future_caption: '',
            future_due: 0,
            future_due_perc: 0,
            current_month_caption: '',
            current_month:0,
            current_month_perc:0,
            current_due_caption: '',
            current_due: 0,
            current_due_perc: 0,
            day3160_caption: '',
            day3160: 0,
            day3160_perc: 0,
            day6190_caption: '',
            day6190: 0,
            day6190_perc: 0,
            day91_caption: '',
            day91_plus: 0,
            day91_plus_perc: 0,
            total_owed: 0,
            total_owed_perc: 0,
            past_due: 0,
            past_due_perc: 0,

            available_credit: 0,
            ytd_purchases: 0,
            mtd_purchases: 0,
            last_invoice_date: '',
            last_payment_date: '',
            last_invoice: '',
            last_payment: '',
            credit_limit: 0,
        };
    },
    mixins: [Price],
    methods: {
        customer_billing_status() {
            axiosvl.post(this.$store.getters['api/billing_status_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                // aging
                this.future_caption = fields.R3HDG1.value;
                this.future_due = fields.CMARB1.value;
                this.future_due_perc = fields.PCT1.value;
                this.current_month_caption = fields.R3HDG2.value;
                this.current_month = fields.CMARB2.value;
                this.current_month_perc = fields.PCT2.value;
                this.current_due_caption = fields.R3HDG3.value;
                this.current_due = fields.CMARB3.value;
                this.current_due_perc = fields.PCT3.value;
                this.day3160_caption = fields.R3HDG4.value;
                this.day3160 = fields.CMARB4.value;
                this.day3160_perc = fields.PCT4.value;
                this.day6190_caption = fields.R3HDG5.value;
                this.day6190 = fields.CMARB5.value;
                this.day6190_perc = fields.PCT5.value;
                this.day91_caption = fields.R3HDG6.value;
                this.day91_plus = fields.CMARB6.value;
                this.day91_plus_perc = fields.PCT6.value;
                this.total_owed = fields.ARBT.value;
                this.total_owed_perc = fields.PCTT.value;
                this.past_due = fields.ARBP.value;
                this.past_due_perc = fields.PCTP.value;

                this.available_credit = fields.AVAILCRD.value;
                this.ytd_purchases = fields.INVYTD.value;
                this.mtd_purchases = fields.INVMTD.value;
                this.last_invoice_date = fields.CMMLIV.value + '/' + fields.CMDLIV.value + '/' + fields.CMYLIV.value;
                this.last_invoice = fields.CMALIV.value;
                this.last_payment_date = fields.CMMLPY.value + '/' + fields.CMDLPY.value + '/' + fields.CMYLPY.value;
                this.last_payment = fields.CMALPY.value;
                this.open_order = fields.CMAOPO.value;
                this.credit_limit = fields.CMCRLT.value;
            })
            .catch((error) => {
                this.isloading = false;
                console.error("error - " + error);
            });
        }
    },

    created() {
        this.customer_billing_status();
    }

}
</script>